<template>
  <footer>
    <div class="row justify-content-center mb-0 pt-5 pb-0 row-2 px-3" style="font-size: 14px;">
      <div class="col-12">
        <div class="row row-2">
          <div class="col-sm-1 text-md-center">
            <h6><span> <i class="fa fa-firefox text-light" aria-hidden="true"></i>
              </span><strong>Notas</strong>
            </h6>
          </div>
          <div class="col-md-8 my-sm-0 mt-5">
            <ul class="list-unstyled">
              <small>
                <li class="mt-0">* Cada terapeuta formado aqui inserido, disponibilizou e preencheu seus dados por livre vontade. 
                  Estando a Denise Mascarenhas e sua equipe isentos de quaisquer responsabilidades por tal.
                  <br/>
                  ** A Denise Mascarenhas e sua equipe, não se responsabilizam pelo conteúdo e metodologia aplicada por cada terapeuta.
                </li>
                </small>
            </ul>
          </div>
            </div>
            </div>
    </div>
    <div class="row justify-content-center mt-0 pt-0 row-1 mb-0 px-sm-3 px-2">
      <div class="col-12">
        <div class="row my-4 row-1 no-gutters">
          <div class="col-sm-3 col-auto text-center"><small>&#9400; Maha Lilah - Denise Mascarenhas</small></div>
          <div class="col-md-3 col-auto "></div>
          <div class="col-md-3 col-auto"></div>
          <div class="col my-auto text-md-left text-right "><small> contato@denisemascarenhas.com.br </small>
            <span style="font-size: 20px; margin: 5px;">
              <a class="social-link" target="_blank" 
                href="https://www.facebook.com/mahalilah.denisemascarenhas"
              >
                <i class="fa fa-facebook px-2"></i>
              </a>
              <a class="social-link" target="_blank" 
                href="https://www.instagram.com/maha_lilah">
                <i class="fa fa-instagram px-2"></i>
              </a>
              <a class="social-link" target="_blank" 
                href="https://www.youtube.com/channel/UCB0s0vjtZ8EV5pDQWz8xM1Q">
                <i class="fa fa-youtube px-2"></i>
              </a>  
            </span>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {

}
</script>

<style scoped>

 /* unvisited link */
.social-link:link {
  color: white;
}

/* visited link */
.social-link:visited {
  color: white;
}

/* mouse over link */
.social-link:hover {
  color: white;
}

/* selected link */
.social-link:active {
  color: white;
} 

 @import url('https://fonts.googleapis.com/css?family=Rubik&display=swap');

  body {
  font-family: 'Rubik', sans-serif;
  height: 100% !important;
  background-color: #F8F9FB !important;
  width: 100%;
 }

 .container-fluid {
  margin-top: 101px;
  color: #000 !important
 }

 .card {
  background-color: #F8F9FB !important
 }

 p {
  font-size: calc(12px + (14 - 12) * ((100vw - 360px) / (1600 - 360))) !important;
  display: fkex
 }

 h3 {
  font-size: calc(24px + (30 - 24) * ((100vw - 360px) / (1600 - 360))) !important
 }

 .social {
  font-size: 21px !important
 }

 .color-text {
  color: #757575 !important
 }

 button {
  font-size: calc(12px + (13 - 12) * ((100vw - 360px) / (1600 - 320))) !important;
  background-color: #2CA6FB !important;
  padding-left: calc(20px + (28 - 20) * ((100vw - 360px) / (1600 - 360))) !important;
  padding-right: calc(20px + (28 - 20) * ((100vw - 360px) / (1600 - 360))) !important;
  padding-top: calc(10px + (12 - 10) * ((100vw - 360px) / (1600 - 360))) !important;
  padding-bottom: calc(10px + (12 - 10) * ((100vw - 360px) / (1600 - 360))) !important
 }

 button:focus {
  -moz-box-shadow: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  outline-width: 0
 }

 footer {
  color: #caced1 !important;
 }

 li {
     margin-top: 20px;
     margin-bottom: 20px
 }

 .Careers {
     cursor: pointer;
     color: #1E88E5
 }

 .row-1 {
     background-color: #550f24 !important
 }

 .row-2 {
     background-color: #851838 !important
 }


.legal-notes {
  margin-top: 20px;
}

</style>